"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const success = {
    100: '#D1F3E7',
    200: '#A5E6CF',
    300: '#7AD7B6',
    400: '#50C79D',
    500: '#28B583',
    600: '#1E9369',
    700: '#157050',
    800: '#0D4B35',
    900: '#06261B'
};
exports.default = success;
